module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-G-Video.caeaef75.jpg";